/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import useDebouncedEffect from './useDebouncedEffect';
import { useSearchTrips } from './hooks/useSearchTrips'

const Main = ({ plugin }) => {
  const { trips, searchTrips, getTripDetails, error, reset, loading, selectedTrip } = useSearchTrips()
  const [searchVal, setSearchVal] = React.useState('');
  const [fieldValue, setFieldValue] = React.useState(plugin.getFieldValue(plugin.fieldPath));
  const parsedValue = JSON.parse(fieldValue) || null;

  React.useEffect(() => {
    if (selectedTrip !== null) {
      plugin.setFieldValue(plugin.fieldPath, JSON.stringify(selectedTrip));
    }
  }, [selectedTrip])

  React.useEffect(() => {
    plugin.addFieldChangeListener(plugin.fieldPath, (newValue) => {
      setFieldValue(newValue);
      reset();
      setSearchVal('');
    });
  }, []);

  useDebouncedEffect(() => {
    searchTrips(searchVal)
  }, 500, [searchVal]);

  return (
    <>
      {parsedValue && parsedValue.name ? (
        <>
          <p className="selected">
            {`${parsedValue.status} / ${parsedValue.name} (ID: ${parsedValue.id})`}
            {!loading && (
              <button tabIndex={-1} role="button" onClick={() => getTripDetails()}>
                X
              </button>
            )}
          </p>
          {!loading && (
            <p className="get_latest">
              <button type="button" onClick={() => getTripDetails(parsedValue.id)}>
                Get latest trip object
              </button>
            </p>
          )}
          {loading && (
            <p className="loading">
              <i>Getting trip details, it might take few seconds...</i>
            </p>
          )}
        </>
      ) : (
        <>
          <div className="form">
            <input
              value={searchVal}
              disabled={loading}
              placeholder={`Search for Trip...`}
              onChange={e => setSearchVal(e.target.value)}
            />
          </div>
          {loading && <p className="loading">Loading...</p>}
          {error && <p className="error">{error}</p>}
          {trips.length > 0 && (
            <div className="results">
              {trips.map(item => (
                <div
                  key={item.id}
                  tabIndex={-1}
                  role="button"
                  onKeyUp={() => getTripDetails(item.id)}
                  onClick={() => getTripDetails(item.id)}
                >
                  {item.name} - <strong style={{ color: item.status === 'active' ? 'green' : 'orange' }}>{item.status}</strong> - (ID: {item.id})
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

Main.propTypes = {
  plugin: PropTypes.object,
};

export default Main;
